<template>
  <div id="app">

    <transition mode="out-in"
                enter-active-class="animated fadeIn">
      <router-view/>
    </transition>

  </div>
</template>

<script>
import ui from "@/assets/scripts/ui";

export default {

  name: 'App',
  data() {
    return {
    }
  },
  methods: {

    msg(title,message,callback = null,size = ''){
      ui.msg(this,title,message,callback,size)
    },

    go(name){
      this.$router.push({name: name})
    },
  },
  mounted() {

    if (localStorage.getItem('language')) {

      let language = JSON.parse(localStorage.getItem('language'))
      this.$translate.setLang(language.type)

    } else {
      //Routes

      let language = {
        type: 'pt-BR',
        name: 'Português'
      }

      this.$translate.setLang(language.type)
      localStorage.setItem('language', JSON.stringify(language))

    }

    if (localStorage.getItem('account')) {
      const account = JSON.parse(localStorage.getItem('account'))

      this.$store.commit("setAccount", account)
      //console.log('Usuario logado: ' + JSON.stringify(this.account))
    }

  }
}
</script>
<style>
</style>